import { CreatedAtFilter } from "@/features/job/components/jobList/filter/CreatedAtFilter";
import { JobLocationFilter } from "@/features/job/components/jobList/filter/JobLocationFilter";
import { JobPriceFilter } from "@/features/job/components/jobList/filter/JobPriceFilter";
import { JobTypeDesktopFilter } from "@/features/job/components/jobList/filter/JobTypeDesktopFilter";
import { JobTypeMobileFilter } from "@/features/job/components/jobList/filter/JobTypeMobileFilter";
import { WorkTimeTypeFilter } from "@/features/job/components/jobList/filter/WorkTimeTypeFilter";

export const mobileJobListFilterList = [
  { title: "分類", component: <JobTypeMobileFilter /> },
  { title: "地區", component: <JobLocationFilter /> },
  { title: "薪酬", component: <JobPriceFilter /> },
  { title: "工作模式", component: <WorkTimeTypeFilter /> },
  { title: "刊登日期", component: <CreatedAtFilter /> },
];

export const desktopJobListFilterList = [
  { title: "分類", component: <JobTypeDesktopFilter /> },
  { title: "薪酬", component: <JobPriceFilter /> },
  { title: "工作模式", component: <WorkTimeTypeFilter /> },
  { title: "刊登日期", component: <CreatedAtFilter /> },
];
